import { useKeywordsStateContext } from '../../datasets/state/useKeywordsState'

export const useDatasetData = () => {
  const [keywordData] = useKeywordsStateContext().comparedKeywords
  return keywordData?.dataset
}
